import React from "react";
import { Typography } from "antd";
const { Title, Paragraph } = Typography;

const FileNotFound = () => {
  return (
    <div>
      <Title level={2}>
        Sorry, the page you tried 
        <br />
            can't be found.
      </Title>
      <Paragraph className="common-paragraph">
        It is possible you typed the address incorrectly, 
        <br />
        or that the page has been moved or removed
        from the site. If you're looking for a particular document, please try one of the following
        areas:
      </Paragraph>
      <Paragraph className="common-paragraph">
        <strong>
            Please try a search on <a href="/">chevrontechnologymarketing.com</a>.
        </strong>
      </Paragraph>
    </div>
  );
};

export default FileNotFound;